module.exports = __webpack_public_path__ + "static/media/lottery-che@2x.4c40cd81.png";